module.exports = __webpack_public_path__ + "static/media/amanda-tavares-avatar.1de3699c.svg";